import { memo } from 'react'

const Spinner = memo(() => {
  return (
    <div className="wc-preloader">
      <div className="wc-preloader__circle" />
      <div className="wc-preloader__circle" />
      <div className="wc-preloader__circle" />
      <div className="wc-preloader__circle" />
    </div>
  )
})

export default Spinner
